<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">
      <a [routerLink]="['/dash/companies/']" *ngIf="udta.level <= 3">Empresas</a>
      <a [routerLink]="['/dash/company/']" *ngIf="udta.level >= 4">Mis Programas</a>
      / Detalle del programa</p>
    <h2 class="">Usuarios asignados a la empresa</h2>
  </div>
  <dx-button text="Nuevo usuario" icon="plus" type="default" (onClick)="grid.instance.addRow()">
  </dx-button>
</div>
<div class="dx-card content-block">
  <div class="responsive-paddings">
    <h2 class="">Datos del programa</h2>
    <div class="flex flex-nowrap flex-space-between  round-border">
      <div class="mr-5">
        <ul *ngIf="programData" class="list-no-style">
          <li>
            <strong> Nombre: </strong> 
            {{programData.name}}</li>
          <li>
            <strong> Dispersión máxima: </strong>
            {{programData.dispersionMaxAmount |  currency:'':'$': '1.0-0'}}
          </li>
          <!--<li>
            <strong> Dispersión máxima por tarjeta: </strong>
            {{ programData.cardDispersionMaxAmount != null ? (programData.cardDispersionMaxAmount |  currency:'':'$': '1.0-0') : 'N/A' }}</li>-->
          <li>
            <strong> Costo x dispersión: </strong> 
            {{programData.companyCosts.dispersionCost | percent :'2.1'}}
          </li>
          <li>
            <strong> Costo x reemplazo de tarjeta: </strong>
            {{programData.companyCosts.cardReplacement |  currency:'':'$': '1.0-0'}}
          </li>
        </ul>
      </div>
      <!-- <div class="mr-5">
        <h2>Costos de empresa</h2>
        <ul class="list-no-style">
          <li><strong> Setup de programa:</strong>
            {{programData.companyCosts.programSetup |  currency:'':'$': '1.0-0'}}
          </li>
          <li><strong> Costo mensual:</strong> {{programData.companyCosts.monthlyCost |  currency:'':'$': '1.0-0'}}
          </li>
          
          <li><strong> Costo x creación de
              tarjeta:</strong>{{programData.companyCosts.cardCreation |  currency:'':'$': '1.0-0'}}</li>
          <li><strong> Costo anual de
              programa:</strong>{{programData.companyCosts.yearlyCost |  currency:'':'$': '1.0-0'}}</li>
          
        </ul>
      </div>
      <div class="mr-5">
        <h2>Costos de usuario</h2>
        <ul class="list-no-style">
          <li><strong> Costo mensual:</strong> {{programData.userCosts.monthlyCost |  currency:'':'$': '1.0-0'}}
          </li>
          <li><strong> Costo x creación de
              tarjeta:</strong>{{programData.userCosts.cardCreation |  currency:'':'$': '1.0-0'}}</li>
          <li><strong> Costo anual de
              programa:</strong>{{programData.userCosts.yearlyCost |  currency:'':'$': '1.0-0'}}</li>
          <li><strong> Costo x
              transacción:</strong>{{programData.userCosts.transactionCost |  currency:'':'$': '1.0-0'}}
          <li><strong> Costo x transferencia
              virtual:</strong>{{programData.userCosts.virtualWireingCost |  currency:'':'$': '1.0-0'}}
          <li><strong> Costo x transferencia
              banncaria:</strong>{{programData.userCosts.bankWireingCost |  currency:'':'$': '1.0-0'}}
          </li>
        </ul>
      </div> -->
    </div>
    <br>
    <br>
    <h2 class="mt-4">Empleados del programa</h2>
    <div class="dx-field pt-3">
      <dx-button id="button" icon="xlsxfile" text="Exportar" 
        class="float-right" (onClick)="onExporting($event)" type="default">
      </dx-button>
    </div>
    <dx-data-grid #grid [dataSource]="usersList" [repaintChangesOnly]="true" keyExpr="id" [allowColumnReordering]="true"
      (onRowInserting)="addNewUser($event)" (onRowUpdating)="updateUser($event)" (onEditingStart)="disableFields($event)" (onInitNewRow)="onInitNewRow($event)"
      [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }" showBorders="true"
      (onRowRemoving)="deleteData($event.key)">
      <dxo-load-panel [enabled]="true"></dxo-load-panel>
      <!-- <dxo-filter-row visible="true" applyFilter="currentFilter"></dxo-filter-row> -->
      <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
      <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="true">
        <dxo-popup title="Nuevo usuario" [showTitle]="true" [width]="750" [height]="780"></dxo-popup>
        <dxo-form>
          <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
            <dxi-item dataField="name" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
              <dxi-validation-rule type="custom" 
                [validationCallback]="cleanString" 
                message="Nombre no permite los caracteres áéíóúÁÉÍÓÚÑñ-_">
               </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="middleName" dataType="string" [isRequired]="false">
              <dxo-label text="Segundo nombre"></dxo-label>
            </dxi-item>
            <dxi-item dataField="lastName" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
              <dxi-validation-rule type="custom" 
                [validationCallback]="cleanString" 
                message="Primer apellido no permite los caracteres áéíóúÁÉÍÓÚÑñ-_">
             </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="secondLastName" dataType="string">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
              <dxi-validation-rule type="custom" 
                [validationCallback]="cleanString" 
                message="Segundo apellido no permite los caracteres áéíóúÁÉÍÓÚÑñ-_">
               </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="phone" dataType="string" [editorOptions]="{ mask: '(000) 000-00-00'}"
                      [template]="'phoneFormat'">
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item *ngIf="companyData && !companyData.userWithNoApp" dataField="email" dataType="string" [disabled]="emailDisabled">
              <dxi-validation-rule type="email" message="Email es invälido">
              </dxi-validation-rule>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item *ngIf="companyData && companyData.userWithNoApp" dataField="email" dataType="string" [disabled]="emailDisabled">
            </dxi-item>
            <dxi-item dataField="city" dataType="string" [isRequired]="true">
              <dxo-label text="Ciudad"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
              <dxi-validation-rule type="stringLength" [max]="15"
                message="Este campo puede contener un máximo de 15 caracteres">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="birthDate" dataType="date" [isRequired]="true" [template]="'birthDateSelect'" [disabled]="emailDisabled">
              <dxo-label text="Fecha de nacimiento"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="gender" dataType="string" [isRequired]="true">
              <dxo-label text="Género"></dxo-label>
              <dxi-validation-rule type="required" message="Campo requerido">
              </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="rfc" dataType="string" [isRequired]="false" cssClass="uper-case">
            </dxi-item>
            <dxi-item dataField="userNumber" dataType="string" [isRequired]="false">
              <dxo-label text="# de empleado"></dxo-label>
            </dxi-item>
            <dxi-item dataField="ine" dataType="string" [isRequired]="false" cssClass="uper-case"></dxi-item>
            <dxi-item dataField="passport" dataType="string" [isRequired]="false" cssClass="uper-case"></dxi-item>
          </dxi-item>
          phoneFormat
          <div *dxTemplate="let data of 'phoneFormat'">
            <dx-text-box  type="text" [(value)]="phone">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
          <div *dxTemplate="let data of 'birthDateSelect'">
            <dx-date-box displayFormat="shortdate" type="date" [(value)]="tempBirthDate">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </div>
        </dxo-form>
      </dxo-editing>
      <dxi-column dataField="name" caption="Nombre"></dxi-column>
      <dxi-column dataField="lastName" caption="Primer apellido" dataType="string"></dxi-column>
      <dxi-column dataField="secondLastName" caption="Segundo apellido" dataType="string"></dxi-column>
      <dxi-column dataField="email" caption="e-mail" dataType="string"></dxi-column>
      <!--
      <dxi-column dataField="tarjeta" caption="Tarjeta" dataType="string" cellTemplate="tarjeta"></dxi-column>
      <dxi-column dataField="nip" caption="NIP" dataType="string" cellTemplate="nip"></dxi-column>
      -->
      <dxi-column dataField="id" caption="Tarjeta activa" dataType="string" cellTemplate="userActive" alignment="center"></dxi-column>
      <dxi-column dataField="ine" caption="INE" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="passport" dataType="string" caption="Pasaporte" [visible]="false"></dxi-column>
      <dxi-column dataField="middleName" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="city" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="rfc" dataType="string" [visible]="false"></dxi-column>
      <dxi-column dataField="gender" dataType="string" [visible]="false">
        <dxo-lookup [dataSource]="genderOptions" displayExpr="name" valueExpr="val">
        </dxo-lookup>
      </dxi-column>
      
      <dxi-column type="buttons" [width]="110">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button hint="Detail" icon="far fa-id-card" [visible]="true" [onClick]="onClickDetail"></dxi-button>
      </dxi-column>

      <div *dxTemplate="let user of 'detail'">
        <div class="flex flex-nowrap flex-start datagrid-detailsW">
          <div class="mr-5 ml-5">
            <h2>Detalle de usuario</h2>
            <ul>
              <li>Empresa: {{user.data.companyName}}</li>
              <li>Nombre: {{user.data.name}} {{user.data.middleName}} {{user.data.lastName}}
                {{user.data.secondLastName}}</li>
              <li>Email: {{user.data.email}}</li>
              <li>Tel: {{user.data.phone}}</li>
              <li>Fecha de nacimiento: {{user.data.birthDate}}</li>
              <li># empleado: {{user.data.userNumber}}</li>
              <li>ID ihunter: {{user.data.id}}</li>
              <li><span *ngIf="user.data.active"><i class="fad fa-check-circle brand-color"></i></span><span
                  *ngIf="!user.data.active"><i class="fad fa-do-not-enter dangerColor"></i></span> Activo</li>
            </ul>
          </div>
          <div class="mr-5 ml-5" *ngIf="user.data.program[0].card">
            <h2>Detalle de tarjeta</h2>
            <ul>
              <ng-container *ngFor="let p of user.data.program">
                <li>Programa: {{p.programName}}</li>
                <li>Convenio: {{p.agreementNNumber}}</li>
                <li *ngIf="p.card">
                  Tarjeta: 
                  <ng-container *ngIf="!p.card.Tarjeta"> **** **** **** {{p.card.number}}</ng-container>
                  <ng-container *ngIf="p.card.Tarjeta">{{ p.card.Tarjeta }}</ng-container>
                </li>
                <li>
                  Tarjeta activada
                  <span *ngIf="!p.card"><i class="fad fa-do-not-enter dangerColor"></i></span>
                </li>
                <li *ngIf="p.card">Fecha de activación: {{p.card.dateCardAssigned | date: 'yyyy-MM-dd hh:mm a'}}</li>
                <li *ngIf="p.card">Status de NIP: {{p.card.statusNIP}}</li>
                <li *ngIf="p.card.NIP">NIP: {{p.card.NIP}}</li>
              </ng-container>
            </ul>
          </div>

          <div style="display: flex; flex-direction: column;">
            <h2>Acciones</h2>
            <div class="mb-3">
              <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="updateUserEmail($event,user)"
                text="Actualizar e-mail">
              </dx-button>
            </div>
            <ng-container *ngIf="user.data.program[0].card">
              <div class="mb-3">
                <dx-button  id="button" [useSubmitBehavior]="true" type="default" (onClick)="getNip($event,user)"
                  text="Ver NIP">
                </dx-button>
              </div>
              <div class="mb-3" *ngIf="!user.data.appUser && user.data.program[0].card">
                <dx-button  id="button" [useSubmitBehavior]="true" type="default" (onClick)="updateNip($event,user)"
                  text="Actualizar NIP">
                </dx-button>
              </div>
              <div class="mb-3">
                <dx-button  id="button" [useSubmitBehavior]="true" type="default" (onClick)="getCardNumber($event,user)"
                  text="Ver Número de Tarjeta">
                </dx-button>
              </div>
              <div class="">
                <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="addCard($event,user)"
                  text="Agregar Tarjeta" class="float-right">
                </dx-button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div *dxTemplate="let card of 'userActive'">
        <span *ngIf="card.data.program[0].card"><i class="far fa-check-square status-3 status-ico"></i></span>
        <span *ngIf="!card.data.program[0].card">
          <dx-button text="Activar" icon="" type="default" (onClick)="showInfo($event, card)"></dx-button>
        </span>
      </div>
      <div *dxTemplate="let user of 'tarjeta'">
        <span *ngIf="user.data.program[0].card">
          <i *ngIf="false" class="far fa-credit-card"></i>
          {{ user.data.program[0].card.cardNumberCacao ? user.data.program[0].card.cardNumberCacao : '' }}
        </span>
      </div>
      <div *dxTemplate="let user of 'nip'">
        <ng-container *ngIf="!user.data.appUser"></ng-container>
        <span *ngIf="user.data.program[0].card && user.data.program[0].card.NIP">{{ user.data.program[0].card.NIP }}</span>
      </div>
    </dx-data-grid>
  </div>

  <!-- POP UP - ACTIVAR TARJETA  -->
  <dx-popup [width]="450" [height]="230" [showTitle]="true" title="Activar tarjeta" [dragEnabled]="false" [closeOnOutsideClick]="true" [(visible)]="popupVisible">
    <div class='dx-field dx-field-label-top'>
        <div class='dx-field-label'>Número de Tarjeta</div>
        <div class='dx-field-value'>
            <dx-text-box mask="0000 0000 0000  0000" [(value)]="tarjeta">
              <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              <dxi-validation-rule type="numeric" message="Deben ser solo digitos"></dxi-validation-rule>
            </dx-text-box>  
            <dx-number-box *ngIf="false" format="#0000 #0000 #0000 #0000" [(value)]="tarjeta" [max]="99999999999999999">
                <!--<dx-validator>
                    <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                </dx-validator>-->
            </dx-number-box>
        </div>
    </div>
    <div class="flex flex-no-wrap flex-space-between mt-4 mb-2 float-right">
        <dx-button id="button" [useSubmitBehavior]="true" type="default"
            text="Activar" class="float-right" (onClick)="activateCard($event)">
        </dx-button>
    </div>
  </dx-popup>

  <!-- POP UP - ACTUALIZAR NIP  -->
  <dx-popup [width]="400" [height]="250" [showTitle]="true" title="Actualizar NIP" [closeOnOutsideClick]="true" [(visible)]="popupVisibleNip">
    <div *dxTemplate="let data of 'content'">
      <div class="flex flex-nowrap popup-form">
        <div class=" responsive-paddings flex-grow-1">
          <div class='dx-field'>
            <div class='dx-field-label'>Actualizar NIP :</div>
            <div class='dx-field-value'>
              <dx-text-box [(value)]="newNIP">
                <dx-validator>
                  <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </div>
          <div class="dx-field pt-3">
            <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="updateCardNIP($event)"
              text="Actualizar" class="float-right">
            </dx-button>
          </div>
        </div>
      </div>
    </div>
  </dx-popup>

  <!-- Popup Actualizar Email -->
  <dx-popup
    [width]="500"
    [height]="250"
    [showTitle]="true"
    title="Actualizar e-mail"
    [closeOnOutsideClick]="true"
    [(visible)]="popupVisibleEmail">
      <div *dxTemplate="let data of 'content'">
        <div *ngIf="userSelected" class="">
          <div class="responsive-paddings">
            <div class='dx-field'>
              <div class='dx-field-label'>Nuevo Email: </div>
              <div class='dx-field-value'>
                <dx-text-box [(value)]="userSelected.email">
                </dx-text-box>
              </div>
            </div>
            <div class="float-right">
              <dx-button id="buttonCancel" type="" text="Cancelar" class="mr-3" (click)="closePopup('email')"></dx-button>
              <dx-button id="button" [useSubmitBehavior]="true" type="default" text="Actualizar" (onClick)="showUpdateUserEmail($event)"></dx-button>
            </div>
          </div>
        </div>
      </div>
  </dx-popup>
  <dx-load-panel
      #loadPanel
      shadingColor="rgba(0,0,0,0.4)"
      [position]="loadingPosition"
      [(visible)]="loadingVisible"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [closeOnOutsideClick]="false"
      (onShown)="onShowLoadingPanel($event)"
      (onHidden)="onHideLoadingPanel($event)">
  </dx-load-panel>

  <div class="responsive-paddings">
    <form id="form_csv" [formGroup]="uploadForm" enctype="multipart/form-data">
      <div class="upload-container round-border">
        <h3>Subir base de datos de empleados</h3>
        <div class="uploaddContent">
          Desde aqui podrás cargar un archivo .csv con todos los empleados. <br>
          Descarga la <a download href="./assets/files/Plantilla de  usuarios con Aplicacion.csv">Plantilla de  usuarios con Aplicación</a> con el formato
          correcto.<br /><br />
          Descarga la <a download href="./assets/files/Plantilla de  usuarios sin Aplicacion.csv">Plantilla de  usuarios sin Aplicación</a> con el formato
          correcto.<br /><br />
          <strong>IMPORTANTE</strong> no tocar el primer renglón del archivo con el nombre de las columnas.<br>
          <div class=" mt-3">
            <input type="file" name="csvreport" id="csvreport" (change)="fileupload($event)"><br>
            <dx-button text="Subir Archivo" icon="plus" type="default" (onClick)="onSubmitFileCsv()" class="mt-2">
            </dx-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
